import React from 'react';
import CommonDropdown from './CommonDropdown';
import PropTypes from 'prop-types';
import './forminputs.css';
import { Wrapper, Label } from './fomInput';
import MultiSelectCommonDropdown from './MultiSelectCommonDropdown';
import { TRANSACTION_BEFORE_WHITE_ICON } from '@Images';
function validateValue(object) {
  if (Array.isArray(object)) return object.length && true;
  return object && true;
}

class RenderCommonDropdownField extends React.Component {
  onBlur = () => {
    let { wasTouched } = this.state;
    !wasTouched && this.setState({ wasTouched: true });
  };

  OpenDropdown = () => {
    // Explicitly focus the text input using the raw DOM API
    this.inputElement.open();
  };

  constructor(props) {
    super(props);
    this.state = {
      is_focus: false,
      changedLabel: null,
      wasTouched: false
    };
  }

  render() {
    const {
      bindToThisObject,
      placeholder,
      selectedLabel,
      className = '',
      getOptions,
      $noDropdownIcon,
      labelClassName,
      parentRef
    } = this.props;
    let { props } = this;
    const Component = !props.multiple ? CommonDropdown : MultiSelectCommonDropdown;

    return (
      <Wrapper
        $toggleFeature={this.props.toggleFeature}
        $noDropdownIcon={$noDropdownIcon}
        className={`common-dropdown-wrapper ${className} ${props.disabled ? 'disabled' : ''}`}
      >
        <div className="input-error-wrapper">
          {(bindToThisObject && !props.multiple) || validateValue(props.input.value) ? (
            <Label $marginTop={props.multiple ? '-10px' : 0} className={labelClassName}>
              {' '}
              {placeholder}{' '}
            </Label>
          ) : (
            this.state.is_focus &&
            !props.multiple && (
              <Label $marginTop={props.multiple ? '-10px' : 0} className={labelClassName}>
                {' '}
                {placeholder}{' '}
              </Label>
            )
          )}

          <Component
            {...props.input}
            enableThis={props.enableThis}
            emptyOnNotFound={props.emptyOnNotFound}
            getOptions={getOptions}
            id={props.id ? props.id.replace('_', '-') : props.input.name.replace(/_/g, '-')}
            fluid={props.fluid}
            staticValues={props.staticValues}
            bindToThisObject={props.bindToThisObject}
            dependedOnObject={props.dependedOnObject}
            placeholder={props.placeholder}
            url={props.url}
            onDropdownClose={props.onDropdownClose}
            onDropdownChange={props.onDropdownChange}
            onPreFilled={props.onPreFilled}
            selectOnClose={props.selectOnClose}
            disabled={props.disabled || props.showDisabledWithIcon}
            multiple={props.multiple}
            showImage={props.showImage}
            showLoader={props.showLoader}
            changeLabel={this.changeLabel}
            isCompact={props.isCompact}
            isUpward={props.isUpward}
            isSearchable={props.isSearchable}
            formName={props.meta.form}
            fieldName={props.input.name}
            code={props.code}
            dispatch={props.meta.dispatch}
            preselect_if_one_item={props.preselect_if_one_item}
            selectedLabel={props.selectedLabel}
            preselect_and_disable_if_one_item={props.preselect_and_disable_if_one_item}
            optional={props.optional}
            sort={props.sort}
            inputRef={(el) => (this.inputElement = el)}
            onBlur={this.onBlur}
            ref={parentRef}
          />
          {(props.meta.touched || this.state.wasTouched) &&
            ((props.meta.error && (
              <div
                className={`error-msg ${
                  props.errorMargin ? 'payment-method-recepient-error-msg' : ''
                }`}
              >
                {' '}
                {props.meta.error}
              </div>
            )) ||
              (props.meta.warning && <span>{props.meta.warning}</span>))}
          {selectedLabel && (
            <div className="code-overlap-div" onClick={this.OpenDropdown}>
              {selectedLabel}
            </div>
          )}
          {className.includes('img-caret') && (
            <img
              src={TRANSACTION_BEFORE_WHITE_ICON}
              alt="dropdown"
              className="dropdown-light"
              width="15px"
              height="15px"
              style={{ transform: 'rotate(90deg' }}
            />
          )}
        </div>
      </Wrapper>
    );
  }
}

RenderCommonDropdownField.propTypes = {
  id: PropTypes.string,
  input: PropTypes.any,
  $noDropdownIcon: PropTypes.bool,
  bindToThisObject: PropTypes.any,
  placeholder: PropTypes.string,
  url: PropTypes.any,
  meta: PropTypes.any,
  getOptions: PropTypes.func,
  selectedLabel: PropTypes.string,
  staticValues: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  onDropdownChange: PropTypes.func,
  onPreFilled: PropTypes.func,
  fluid: PropTypes.bool,
  optional: PropTypes.bool,
  sort: PropTypes.bool,
  enableThis: PropTypes.any,
  emptyOnNotFound: PropTypes.any,
  dependedOnObject: PropTypes.any,
  onDropdownClose: PropTypes.any,
  selectOnClose: PropTypes.any,
  showDisabledWithIcon: PropTypes.any,
  showImage: PropTypes.any,
  showLoader: PropTypes.any,
  isCompact: PropTypes.any,
  isUpward: PropTypes.any,
  isSearchable: PropTypes.any,
  code: PropTypes.any,
  preselect_if_one_item: PropTypes.any,
  preselect_and_disable_if_one_item: PropTypes.any,
  errorMargin: PropTypes.any,
  toggleFeature: PropTypes.any,
  labelClassName: PropTypes.string,
  parentRef: PropTypes.any
};

export default RenderCommonDropdownField;
